<header>
    
</header>

  

  




<!-- presupuesto -->
@if(isActiveConfig){
    <h1 class="page-header "><i class="fas fa-chart-line"></i>Configuracion <small>{{title}}</small></h1>

<div class="panel p-4">
<app-setting-field-salary-calculated [employeeType]="employeeType"
    (activeChange)="changeSetting();isActiveConfig=$event;title='Presupuesto'"
    [year]="filter.year"
    [version]="filter.version"
    [budgetEmployeeType]="budgetEmployeeType"
    [fundSelected]="fundSelect"
    ></app-setting-field-salary-calculated>
</div>

}

@if(!isActiveConfig){
<div class="row">
    <div class="col-12" [ngClass]="{'col-md-6': budgetFund?.length==1,'col-md-12': budgetFund?.length>1}">
        <h1 class="page-header"><i class="fas fa-calculator"></i> Asistente de Calculo</h1>

    </div>
    @if(budgetFund?.length>1){
        <div class="col-12  mb-3" [ngClass]="{'col-md-6': budgetFund?.length>1}">
   
        <div class="btn-group">           
        @for(f of budgetFund; track f.id){
        <button class="btn btn-white btn-sm" [ngStyle]="{'min-width': '120px'}" [class.active]="fundSelect ==f.fundCode"  (click)="changeFund(f.fundCode)">Fondo {{f.fundCode}}</button>
        }
        </div>
      </div>
    }    
      
    <div class="col-12 mb-3 col-md-6">
        <div class=" d-md-flex fw-bold align-items-center justify-content-end mt-3">
            <div class="">
                <div class="dropdown-toggle">
                    <a href="javascript:;" data-bs-toggle="dropdown"
                        class="text-decoration-none text-dark text-opacity-75"><i
                            class="fa fa-cog fa-fw me-1 text-dark text-opacity-50"></i> Opciones<b
                            class="caret"></b></a>
                    
                    <div class="dropdown-menu">
                        <a (click)="exportToExcel()" class="dropdown-item">Exportar Excel</a>
                        @if(budgetStatus==2){
                        <div role="separator" class="dropdown-divider"></div>

                        <a (click)="syncEmployee()" class="dropdown-item">Sincronizar valores APS</a>
                        }
                         @if(budgetStatus==2){
                        <div role="separator" class="dropdown-divider"></div>

                        <a (click)="openAccountConfig()" class="dropdown-item">Configurar Conceptos</a>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-budget-over-view [data]="items" [filterItemCode]="411"></app-budget-over-view>

@if(budgetEmployeeType?.length>1){
<div class="row">
    <div class="col-12">
        <!-- begin panel -->
        <ul class="nav nav-tabs">
            @for(b of budgetEmployeeType; track b.id;let i = $index){
            <li class="nav-item">
                <a [href]="'#'+b.employeeType" data-bs-toggle="tab" (click)="tabChange(b)" class="nav-link"
                [class.active]="employeeType ==b.employeeType">{{b.employeeTypeName}}</a>
            </li>
            }
        </ul>
    </div>
</div>
}

  
<div class="tab-content panel p-4 " [ngClass]="{ 'rounded-0 rounded-bottom': budgetEmployeeType?.length>1 }">

    <!--Crea las pestañas dependiendo del tipo de empleado-->
    @for(b of budgetEmployeeType; track b.id){
    <div class="tab-pane fade" [ngClass]="{ 'show active ': employeeType==b.employeeType }" id="{{b.employeeType}}">
        @if(itemsAccount[b.employeeType]?.length>0){  


        <div class="row mb-3 mt-2 align-items-center">
            <div class="col-12 col-md-6">
                <ng-select [items]="datalistEmployee[b.employeeType]" [hideSelected]="true" [closeOnSelect]="false"
                    [(ngModel)]="filterByEmployeeType[b.employeeType]" [multiple]="true" bindLabel="nameDiverse"
                    bindValue="diverse" (change)="changeNgSelectFilter(b.employeeType)" placeholder="Seleccione un empleado">
                </ng-select>
            </div>
               <div class="col-12 col-md-3">
                <ng-select [items]="categoryFormula" [hideSelected]="true" [closeOnSelect]="false"
                    [(ngModel)]="categorySelect" [multiple]="true" bindLabel="name"
                    bindValue="code" (change)="changeNgSelectFilterCategory(b.employeeType)" placeholder="Categorias">
                </ng-select>
            </div>
        </div>
        <div #tableData class="table-data">
            <br>
            <table class="table table-sm mt-4 ">
                <thead>
                    <tr>
                        <th class="sticky-column-1 text-nowrap ">N° Diverso</th>
                        <th class="sticky-column-2 text-nowrap  ">Nombre Empleado</th>
                        @for(item of itemsAccount[b.employeeType]; track item.id){
                            <th [ngStyle]="{'min-width': '160px'}" >                    
                                <div class="text-center ">
                                    <span >{{item.name}}  @if(item.hint){
                        <i class="fas fa-question-circle" ngbTooltip="{{item.hint}}" placement="top"
                            [container]="'body'">
                        </i>
                        }</span>
                                    <br>
                                 @if(item.accountCode){
                                    <span >({{item.accountCode}})</span>
                                 }
                                </div> 
                            </th>    
                        }
                    </tr>
                </thead>
                <tbody>

                    @for(employee of Employee[b.employeeType]; track employee.id){
                    <tr>
                        <td class="text-nowrap sticky-column-1 align-middle bg-light text-center">
                            {{employee.employeeCode}}
                        </td>
                        <td class="sticky-column-2 align-middle bg-light">{{employee.employeeNames}}</td>
                        @for(item of itemsAccount[b.employeeType]; track item.id){
                       @if(!item.block&&budgetStatus==2){
                        <ng-template #popoverContent>
                            <div>
                              - Egreso:
                              <strong>
                                ${{ (getValueToltip(employee, item.code, item, employee.typeId).expenseValue)||0 | number: '1.0-0' }}
                              </strong>
                            </div>
                            <div>
                              - Proyectado Anual:
                              <strong>
                                ${{ (getValueToltip(employee, item.code, item, employee.typeId).projectionValue)||0 | number: '1.0-0' }}
                              </strong>
                            </div>
                                       <div>
                              - Promedio Concepto:
                              <strong>
                                ${{ (getValueToltip(employee, item.code, item, employee.typeId).avgValue)||0 | number: '1.0-0' }}
                              </strong>
                            </div>
                          </ng-template>

                    <td class="align-middle text-nowrap" >
                         @if(hasReference(employee, item)){
                        <input  type="text" [ngbPopover]="popoverContent" class="form-control form-control-sm"
                        popoverTitle="Referencia presupuestaria Anual"
                        triggers="focus blur"
                        (keypress)="onlyNumber($event)"
                        #p="ngbPopover"
                        [container]="tableData.nativeElement"
                        placement="top" [ngStyle]="{'min-width': '140px'}"
                                (click)="toggleInput(input.value);selectAll($event)" (focus)="toggleInput(input.value)"
                                #input type="text"
                               [value]="(getAccountValue(employee, item.code, item, employee.typeId) || 0) 
                              | number:('1.' + (item?.decimalPlaces ?? 0) + '-' + (item?.decimalPlaces ?? 0))"
                              (change)="updateValueAccounts(employee, item.code, input.value,employee.typeId)"
                                appNumberFormat>
                        }
                        @else {
                        <input  type="text"  class="form-control form-control-sm"
                        (keypress)="onlyNumber($event)" [ngStyle]="{'min-width': '140px'}"
                                (click)="toggleInput(input.value);selectAll($event)" (focus)="toggleInput(input.value)"
                                #input type="text"
                               [value]="(getAccountValue(employee, item.code, item, employee.typeId) || 0) 
                              | number:('1.' + (item?.decimalPlaces ?? 0) + '-' + (item?.decimalPlaces ?? 0))"
                              (change)="updateValueAccounts(employee, item.code, input.value,employee.typeId)"
                                appNumberFormat>
                        }
                        </td>
                        }@else {
                        <td class="align-middle text-nowrap text-end " [ngStyle]="{'min-width': '140px'}">
                            <span>{{getAccountValue(employee, item.code,item) | number:('1.' + (item?.decimalPlaces ?? 0) + '-' + (item?.decimalPlaces ?? 0))}}</span>
                        </td>
                        }

                        }
                    </tr>
                    }
                </tbody>
                <tfoot>
                    <tr>
                        <th class="sticky-column-1"></th>
                        <th class="sticky-column-2">Sub Totales</th>
                        @for(item of itemsAccount[b.employeeType]; track i;let i= $index){
                         <th class="align-middle text-nowrap text-end">
                            <span>{{getSubtotalValue(item.code,b.employeeType)| number: '1.0-0'}}</span>
                        </th>
                        }

                    </tr>
                </tfoot>
            </table>
        </div>
    }@else if(!isLoading&&itemsAccount[b.employeeType]?.length==0&&budgetStatus==2){
        <div class="alert alert-danger" role="alert">
            Es necesario configurar los campos de viaje.
            <a (click)="openAccountConfig()" class="btn btn-primary btn-sm">Configurar</a>
        </div>
    }
    </div>
    
}

</div>
}


